import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  user: null,
  response: null,
  loading: false,
  error: null,
  callTimes: 0,
  message: '',
  data: []
}

export const productSlice = createSlice({
  name: 'productSliceName',
  initialState,
  reducers: {
    addProduct: (state) => {
      state.loading = true;
    },
    getProduct: (state) => {
      state.loading = true;
    },
    getOneProduct: (state) => {
      state.loading = true;
    },

    successProduct: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    removeProduct: (state) => {
      state.loading = true;
    },
    updateProduct: (state) => {
      state.loading = true;
    },
    emptyCart: (state, action) => {
      state.value += action.payload
    },
    searchProductByName: (state) => {
      state.loading = true;
    }
  },
})

// Action creators are generated for each case reducer function
export const { addProduct, removeProduct, updateProduct, getProduct, successProduct, getOneProduct, searchProductByName } = productSlice.actions

export default productSlice.reducer